import React from 'react';
import styled from 'styled-components';

export default function UserReportBody({reasonList, onSelectReasonChange, onImpostorReasonChange, onEtcReasonChange, onSubmit, selectReason, impostorFieldVisible, etcFieldVisible, valid}) {
    return (
        <UserReportWrapper>
            <UserReportHeader>
                <UserReportHeaderTitle>신고 사유를 선택해주세요.</UserReportHeaderTitle>
                <UserReportHeaderDesc>{"무분별한 신고 시, 불이익이 있을 수 있습니다.\n모티너스 운영팀이 검토 후, 규정 위반 시 계정 정지 및\n후속 조치 취하도록 하겠습니다."}</UserReportHeaderDesc>
            </UserReportHeader>
            <UserReportForm>
                <UserReportList>
                {reasonList.map((reason) => {
                    return (
                        <UserReportItem key={`report_reason_no_${reason.no}`}>
                            <Radio type="radio" id={`reason_no_${reason.no}`} name={reason.type} onChange={() => onSelectReasonChange(reason)}/>
                            <ReportReason htmlFor={`reason_no_${reason.no}`}>
                                <ReportReasonName>{reason.display_name.ko}</ReportReasonName>
                                {reason.name === 'impostor' && impostorFieldVisible ? (
                                    <EtcInput 
                                        onChange={onImpostorReasonChange}
                                        placeholder={"정확한 처리를 위해 구체적으로 누구를 사칭했는지 알려주세요..(최소 10자 이상)"}
                                        readOnly={selectReason && selectReason.name === 'impostor' ? false : true}
                                    /> 
                                ) : null}
                                {reason.name === 'others' && etcFieldVisible ? (
                                    <EtcInput 
                                        onChange={onEtcReasonChange}
                                        placeholder={"정확한 처리를 위해 신고하는 구체적인 사유를 입력해주세요.(최소 10자 이상)"}
                                        readOnly={selectReason && selectReason.name === 'others' ? false : true}
                                    /> 
                                ) : null}
                            </ReportReason>
                        </UserReportItem>
                    )
                })}
                </UserReportList>
            </UserReportForm>
            <UserReportFooterWrapper>
                <UserReportButton valid={valid} onClick={valid ? onSubmit : null}>신고하기</UserReportButton>
            </UserReportFooterWrapper>
        </UserReportWrapper>
    )
};

const UserReportWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y:scroll;
`;

const UserReportHeader = styled.div`
    flex: 0 1 auto;
    padding: calc(100vw * (26 / 375)) calc(100vw * (17 / 375)) 0 calc(100vw * (17 / 375));
`;

const UserReportHeaderTitle = styled.h1`
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
    line-height: calc(100vw * (26.06 / 375));
`;

const UserReportHeaderDesc = styled.p`
    font-size: calc(100vw * (14 /375));
    font-weight: 400;
    white-space: pre-wrap;
    color: #4e4e4e;
    margin-top: calc(100vw * (12 / 375));
`;

const UserReportForm = styled.div`
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    // margin-top: calc(100vw * (26 / 375));
    padding: calc(100vw * (26 / 375)) calc(100vw * (17 / 375)) 0 calc(100vw * (17 / 375));
`;

const UserReportList = styled.ul`
    padding-bottom: calc(100vw * (73 / 375));
`;

const UserReportItem = styled.li`
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #efefef;
    padding: calc(100vw * (16 / 375)) 0;

    &:last-child {
        border-bottom: 0;
    }
`;

const Radio = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FFF;
    border: 1.5px solid #8E8E93;
    width: calc(100vw * (20 / 375));
    height: calc(100vw * (20 / 375));
    border-radius: 100%;
    &:before {
        content: '';
        display: block;
        width: calc(100vw * (12 / 375));
        height: calc(100vw * (12 / 375));
        border-radius: 100%;
    }
    &:checked:before {
        border: 1px solid #121212;
        background: #000;
    }
`;

const ReportReasonName = styled.p`
    fon-size: calc(100vw * (16 / 375));
`;

const ReportReason = styled.label`
    font-size: calc(100vw * (16 / 375));
    font-weight: 400;
    margin-left:calc(100vw * (11 / 375));
`;

const EtcInput = styled.textarea`
    font-size: calc(100vw * (14 / 375));
    background: #F7F7F7;
    width: calc(100vw * (293 / 375));
    height: calc(100vw * (118 / 375));
    margin-top: calc(100vw * (7 / 375));
    padding: calc(100vw * (10 / 375)) calc(100vw * (30 / 375)) 0 calc(100vw * (15 / 375));
    border-radius: calc(100vw * (8 / 375));
    ::placeholder {
        font-size: calc(100vw * (12 / 375));
    }
`;

const UserReportFooterWrapper = styled.div`
    // flex: 0 1 auto;
    height: calc(100vw * (73 / 375));
    max-height: calc(100vw * (73 / 375));
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 300;
`;

const UserReportButton = styled.button`
    font-size: calc(100vw * (18 / 375));
    font-weight: 700;
    line-height: calc(100vw * (26.06 / 375));
    width: 100%;
    height: 100%;
    background: ${({valid}) => valid ? `#FFCF19` : '#D8D8D8'};
    color: ${({valid}) => valid ? `#000` : '#989898'};
`;